import { groq } from '#imports';

export function getQuery({ publishedAt } = {}) {
  return groq`*[_type == "article" && publishedAt < '${publishedAt}' && !(_id in path('drafts.**'))] | order(publishedAt desc)[0]{
    _id,
    slug,
    image,
    title,
    titleColor,
    titleMarkColor,
    subtitle,
    subtitleColor,
    lead,
    isArticleCardsType,
    isArticleExternalSourceType,
    externalSource,
  }`;
}
